import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import province from "../../../containers/modules/master/province";

export default function ProvinceRoute( props ) {
    const {authUser}=props
    return (
        <Route
            path="province"
            index
                element={
                  <AccessControl
                    name={"Province List"}
                    auth={authUser}
                    component={province}
                  />
                }
        />
    )
}